const actionType = {
    GET_ALL_REF_DATA_GC_TABLES: 'GET_ALL_REF_DATA_GC_TABLES',
    GET_ALL_REF_DATA_VIEWS: 'GET_ALL_REF_DATA_VIEWS',
    GET_REF_DATA_VIEWS_DATA: 'GET_REF_DATA_VIEWS_DATA',
    SET_DYNAMIC_VIEW_CONFIGURATION_SUCCESS: 'SET_DYNAMIC_VIEW_CONFIGURATION_SUCCESS',
    GET_VIEW_COLUMN_NAMES: 'GET_VIEW_COLUMN_NAMES',
};

export default actionType;